<script lang="ts">
	import childrenImage3xl from "@assets/images/fathers-family-children.jpg?webp&imagetools";
	import childrenImageXs from "@assets/images/fathers-family-children.jpg?webp&w=800&imagetools";
	import childrenImageSm from "@assets/images/fathers-family-children.jpg?webp&w=960&imagetools";
	import childrenImageMd from "@assets/images/fathers-family-children.jpg?webp&w=1280&imagetools";
	import childrenImageLg from "@assets/images/fathers-family-children.jpg?webp&w=1600&imagetools";
	import childrenImageXl from "@assets/images/fathers-family-children.jpg?webp&w=1920&imagetools";
	import childrenImage2xl from "@assets/images/fathers-family-children.jpg?webp&w=2400&imagetools";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import { ButtonVariant } from "@components/common/ButtonVariant.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { ClassValue } from "svelte/elements";
	import { getMembershipPagePath } from "@core/schema/paths/getMembershipPagePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import ImageSection from "./ImageSection.svelte";
	import translations from "./SubscriptionSection.translations.json" with { type: "json" };

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
	const { class: customClass }: { class?: ClassValue } = $props();
</script>

<ImageSection
	heading={{ text: translate("fathersFamily"), level: 2 }}
	sources={{
		default: childrenImageXs,
		">sm": childrenImageSm,
		">md": childrenImageMd,
		">lg": childrenImageLg,
		">xl": childrenImageXl,
		">2xl": childrenImage2xl,
		">3xl": childrenImage3xl,
	}}
	class={customClass}
	paragraph={translate("discoverOffer")}
	media="object-[50%_33%] h-full object-cover"
	darkOverlay
>
	{#snippet actions()}
		<Link size={ButtonSize.Medium} variant={ButtonVariant.White} href={getMembershipPagePath(tenant)}>
			<Formatted text={translate("subscribeWant")} />
		</Link>
	{/snippet}
</ImageSection>
